module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bN2Dw"))).then(() => parcelRequire('1iHdE'));